import React from 'react';
const Footer = ({ appVersion }) => {
    return (
        <table width="100%" cellSpacing="0" cellPadding="0" >
            <tbody>
                <tr>
                    <td>
                        <div id="footer1">
                            <div id="center1">
                                <footer className="footer">
                                    <div className="container-fluid container-flex">
                                        <div className="footer-box footer-box__logo" style={{ height: "40px" }}>
                                            <a className="svg" href="https://www.fortisbc.com/Pages/default.aspx">
                                                <img src="../../images/FBC-Reverse-166-32.png" /></a>
                                        </div>
                                        <div className="footer-box footer-box__phone">
                                            <div className="DELETED-fbc-widget__ContentBlock">
                                                <div className="contact-item">
                                                    <div className="footer-box footer-box__contact fortis-links">
                                                        <a href="https://www.fortisbc.com/ContactUs/Pages/default.aspx" target="blank">Contact us</a>
                                                    </div>
                                                    <div className="contact-item__value">
                                                    </div>
                                                </div>
                                                <div className="contact-item">
                                                    <div className="contact-item__label">

                                                    </div>
                                                    <div className="contact-item__value">
                                                    </div>
                                                </div>
                                                <div className="contact-item">
                                                    <div className="contact-item__label">

                                                    </div>
                                                    <div className="contact-item__value">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="footer-box footer-box__contact fortis-links">

                                        </div>

                                        <div className="footer-box footer-box__links fortis-links">
                                            <div className="fbc-widget__ContentBlock">
                                                <p><a href="https://www.fortisbc.com/Pages/default.aspx" target="blank">fortisbc.com</a>&nbsp;&nbsp;<em aria-hidden="true" className="fas fa-external-link-alt"></em></p>
                                            </div>
                                        </div>
                                        <div className="footer-box footer-box__social  text-center no-print" style={{ color: "#173A64" }}>
                                            {appVersion}
                                        </div>
                                        <div className="footer-box footer-box__copyright">
                                            <br /><br />
                                            <p><a href="http://www.fortisbc.com/Pages/privacypolicy.aspx">Privacy policy</a></p>
                                            <p><a href="http://www.fortisbc.com/Pages/termsofuse.aspx">Terms of use</a></p>
                                            <p><a href="http://www.fortisbc.com/Pages/sitemap.aspx">Site map</a></p>
                                            <p>© 2026 FortisBC. <a href="http://www.fortisbc.com/Pages/copyright.aspx" style={{ textDecoration: "none" }}>All rights reserved.</a></p>
                                        </div>
                                    </div>
                                </footer>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

    );
};

export default Footer;